<div *ngIf="isLoading" class="loading-indicator">
  <app-progress-bar-circular></app-progress-bar-circular>
</div>
<div #qsContainer class="qs-frame-container"></div>
